export default {
  name: "ArrowButton",
  props: ["title", "dark_button", "no_margin", "click_handler"],
  methods: {},
};
